import debugInit from './debug/index';

import Alpine from 'alpinejs';
import modal from './alpine/modal';
import navMobile from './alpine/navMobile';
import formExpressYourself from './alpine/formExpressYourself';

import swiperTestimonialInit from './modules/swiperTestimonial';
import headerInit from './modules/header';
import animationsInit from './modules/animations';

import { createApp } from 'vue'
import AppQuiz from './components/AppQuiz'

// Alpine
// -------------------------------------------- 
Alpine.data('modal', modal);
Alpine.data('formExpressYourself', formExpressYourself);
Alpine.data('navMobile', navMobile);

window.Alpine = Alpine;
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  console.log('Dom loaded');
  debugInit();
  swiperTestimonialInit();
  animationsInit();
});

window.addEventListener('load', function () {
  console.log('Page loaded');
  headerInit();
})


// Vue
// -------------------------------------------- 
const app = createApp({})

if (document.querySelector("#app")) {
  app.component('app-quiz', AppQuiz)
  app.mount('#app')
}
